import { Badge } from '@radix-ui/themes'

import { TransferStatus, TRANSFER_STATUS_LABELS } from '@/interfaces/Transfer'

type RadixColor =
  | 'gray'
  | 'gold'
  | 'bronze'
  | 'brown'
  | 'yellow'
  | 'amber'
  | 'orange'
  | 'tomato'
  | 'red'
  | 'ruby'
  | 'crimson'
  | 'pink'
  | 'plum'
  | 'purple'
  | 'violet'
  | 'iris'
  | 'indigo'
  | 'blue'
  | 'cyan'
  | 'teal'
  | 'jade'
  | 'green'
  | 'grass'
  | 'lime'
  | 'mint'
  | 'sky'

const STATUS_BADGE_COLORS: Record<TransferStatus, RadixColor> = {
  [TransferStatus.DRAFT]: 'gray',
  [TransferStatus.PENDING_DOCUMENTS]: 'amber',
  [TransferStatus.PENDING_PAYMENT]: 'orange',
  [TransferStatus.PAID]: 'blue',
  [TransferStatus.SENT_TO_TRANSFIERO]: 'indigo',
  [TransferStatus.IN_PROCESS]: 'purple',
  [TransferStatus.SIGNATURE_READY]: 'teal',
  [TransferStatus.NOTARIZED]: 'green',
  [TransferStatus.REGISTERED]: 'jade',
  [TransferStatus.REJECTED]: 'red',
  [TransferStatus.VOIDED]: 'crimson',
}

interface TransferStatusBadgeProps {
  status: TransferStatus
}

export const TransferStatusBadge = ({ status }: TransferStatusBadgeProps) => {
  const color = STATUS_BADGE_COLORS[status] || 'gray'
  const label = TRANSFER_STATUS_LABELS[status] || status

  return (
    <Badge color={color} variant="soft" size="2">
      {label}
    </Badge>
  )
}
